import { useEffect, useState } from 'react';
import api from '../../lib/api';
import { useSettings } from '../../context/SettingsContext';

const Ticker = () => {
  const { modules } = useSettings();
  const [wins, setWins] = useState([]);

  useEffect(() => {
    api.get('/ticker').then((r) => setWins(r.data)).catch(() => {});
  }, []);

  if (modules.ticker === false || !wins.length) return null;
  const items = [...wins, ...wins];

  return (
    <div data-testid="live-wins-ticker" className="bg-bh-canvas border-b border-white/5 overflow-hidden">
      <div className="flex items-center">
        <div className="flex items-center gap-2 px-4 py-2 bg-bh-surface border-r border-white/10 shrink-0 z-10">
          <span className="w-2 h-2 rounded-full bg-bh-emerald pulse-dot" />
          <span className="text-[11px] font-mono-num font-semibold uppercase tracking-wider text-gray-400">Canlı</span>
        </div>
        <div className="flex marquee-track whitespace-nowrap py-2">
          {items.map((w, i) => (
            <span key={i} className="inline-flex items-center gap-2 px-6 text-xs text-gray-400">
              <span className="font-semibold text-gray-200">{w.user}</span>
              <span className="font-mono-num font-bold text-bh-emerald">{w.amount}</span>
              <span className="text-gray-600">·</span>
              <span>{w.game}</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Ticker;
